import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'



import DataTable from "@andresouzaabreu/vue-data-table";
import "bootstrap/dist/css/bootstrap.min.css";
import "@andresouzaabreu/vue-data-table/dist/DataTable.css";
import { setAuthToken } from '../src/services/AuthService.js';
import axios from 'axios';

import 'vue-multiselect-listbox/dist/vue-multi-select-listbox.css';

import 'leaflet/dist/leaflet.css';

import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

export const eventBus = new Vue();



const messages = {
  en: {
    loginHeader:"Login",
    username: "Username",
    password: "Password",
    loginHeaderMessage: "Enter your account",
    captcha: "Captcha",
    sum: "Result of Sum",
    forgetPassword:"Forget password",
    btnLogin: "login",
    errorLoginHeader: "Error!!!",
    captchError: "The entered security phrase (captcha) is incorrect.",
    accept: "Accept",
    userPassError:"The entered Username or Password are incorrect.",
    inactiveAccount:"Dear user, your account has been deactivated. \n Please contact the site administrator.",

    message: {
      value: 'login'
    }
  },
  fa: {
    loginHeader:"ورود",
    username: "نام کاربری",
    password: "رمزعبور",
    loginHeaderMessage: "سامانه هوشمند پایش ناوگان حمل و نقل",
    captcha: "تصویر امنیتی",
    sum: "حاصل جمع",
    forgetPassword:"فراموشی رمزعبور",
    btnLogin: "ورود",
    errorLoginHeader: "خطا در ورود",
    captchError: "تصویر امنیتی وارد شده نادرست است.",
    accept: "قبول",
    userPassError:"نام کاربری یا رمزعبور وارد شده صحیح نمی‌باشد.",
    inactiveAccount:"کاربر گرامی، حساب شما غیرفعال شده است. \n لطفا با مدیر سایت تماس حاصل نمایید.",
    message: {
      value: 'ورود'
    }
  },
};

const i18n = new VueI18n({
  locale: 'fa',
  messages
});


Vue.config.productionTip = false;

Vue.component("data-table", DataTable);

// new Vue({
//   render: (h) => h(App),
// }).$mount("#app");


Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)
Vue.component('date-picker', VuePersianDatetimePicker);

new Vue({
  el: "#app",
  router,
  store,
  icons,
  template: "<App/>",
  components: {
    App,
  },
  i18n,


  created() {
    axios.interceptors.response.use(undefined, (err) => {
      return new Promise((resolve, reject) => {
        if (err.response && err.response.status === 401) {
          const token = null;
          setAuthToken(token);
          this.$router.replace("/").catch(() => { });
        }
        throw err;

      });

    });

  },

});

